/*
 * @Author: zxf
 * @Date: 2022-07-20 14:20:09
 * @LastEditors: zxf
 * @LastEditTime: 2023-06-26 11:32:58
 * @Description: 消防检测项目路由
 */
const xmglRoutes = {
  path: 'xmgl',
  name: 'xmgl',
  component: { template: '<router-view></router-view>' },
  children: [
    {
      path: 'index',
      name: 'xmglIndex',
      component: () => import(/* webpackChunkName: "xmglAll" */'@/features/xfjcgl/xmgl/index.vue'),
      meta: {
        navtabTitle: '项目管理',
        isCache: true,
        ignoreDiff: [],
        menuElements: [
          { elementCode: 'xmgl_search', elementName: '查询' },
          { elementCode: 'jcxm_scbg_ls', elementName: '生成临时报告' },
          { elementCode: 'jcxm_scbg', elementName: '生成报告' },
          { elementCode: 'jcxm_cxjc', elementName: '重新检测' },
          { elementCode: 'jcxm_sqxg', elementName: '申请修改' },
          { elementCode: 'jcxm_qz', elementName: '签章' },
          { elementCode: 'jcxm_gz', elementName: '盖章' }
        ]
      }
    },

    {
      path: 'add',
      name: 'addJcxm',
      component: () => import(/* webpackChunkName: "zxzIndex" */'@/features/xfjcgl/xmgl/add.vue'),
      meta: {
        navtabTitle: '检测项目新增',
        isCache: true,
        ignoreDiff: [],
        menuElements: []
      }
    },
    {
      path: 'edit/:xmId',
      name: 'editJcxm',
      component: () => import(/* webpackChunkName: "zxzIndex" */'@/features/xfjcgl/xmgl/details/edit.vue'),
      meta: {
        navtabTitle: '检测项目编辑',
        isCache: true,
        ignoreDiff: [],
        menuElements: []
      }
    },
    {
      path: 'view/:xmId',
      name: 'viewXfjc',
      component: () => import(/* webpackChunkName: "viewXfjc" */'@/features/xfjcgl/xmgl/details/view.vue'),
      meta: {
        navtabTitle: '检测项目查看',
        isCache: true,
        ignoreDiff: ['showType'],
        menuElements: []
      }
    },
    {
      path: 'xfsb/:type/:xmId',
      name: 'xfsbIndex',
      component: () => import(/* webpackChunkName: "zxzIndex" */'@/features/xfjcgl/xmgl/xfsb/index.vue'),
      meta: {
        navtabTitle: '消防设备管理',
        isCache: true,
        ignoreDiff: [],
        menuElements: []
      }
    },
    {
      path: 'jcx/:xmId',
      name: 'jcxIndex',
      component: () => import(/* webpackChunkName: "zxzIndex" */'@/features/xfjcgl/xmgl/jcx/index.vue'),
      meta: {
        navtabTitle: '项目检测项填报',
        isCache: true,
        ignoreDiff: [],
        menuElements: []
      }
    },
    {
      path: 'jcd/:xmId',
      name: 'jcdIndex',
      component: () => import(/* webpackChunkName: "zxzIndex" */'@/features/xfjcgl/xmgl/jcd/index.vue'),
      meta: {
        navtabTitle: '检测点信息列表',
        isCache: true,
        ignoreDiff: [],
        menuElements: []
      }
    },
    {
      path: 'jcx/:xmId',
      name: 'viewJcx',
      component: () => import(/* webpackChunkName: "viewJcx" */'@/features/xfjcgl/xmgl/jcx/view.vue'),
      meta: {
        navtabTitle: '项目检测项查看',
        isCache: true,
        ignoreDiff: [],
        menuElements: []
      }
    }
  ]
};

export default xmglRoutes;
